import { IVillageCounterSetSchema } from '../../../../node/repositories/countryside-search/entities/counter/VillageCounterSetSchema';
import { INewobjectCategorySetForListPresenterSchema } from '../../../../node/repositories/countryside-search/entities/newobject_category/NewobjectCategorySetForListPresenterSchema';
import { ISeoDataSchema } from '../../../../node/repositories/countryside-search/entities/seo/SeoDataSchema';
import { ON_SALE_OBJECTS } from '../../../interfaces/villages';

export const generateObjectsLink = (
  newObjectKey: keyof INewobjectCategorySetForListPresenterSchema,
  seo?: ISeoDataSchema | null,
  counterSet?: IVillageCounterSetSchema | null,
) => {
  if (!counterSet) {
    return null;
  }

  const onSale = (counterSet[ON_SALE_OBJECTS[newObjectKey]] as number) > 0;

  return onSale && seo ? (seo.url as string) : null;
};
